<template>
    <div>
        <img class="w-100 db" src="@/assets/img/top-rip.svg"/>
            <CardShell class="pa4">
                <slot></slot>
            </CardShell>
        <img class="w-100 db" src="@/assets/img/bottom-rip.svg">
    </div>
</template>
    
<script>
import CardShell from '@/components/global/CardShell.vue';

export default {
    components: {
        CardShell
    }
};
</script>
